import React from 'react';

import { FormComponent, FormComponentProps } from '../../../../components/form';
import css from './balance.module.css';

export default function Balance(
  totals: {
    s: FormComponent;
    n: FormComponent;
    p2o5: FormComponent;
    k2o: FormComponent;
  },
  title: string
): FormComponent {
  return ({ ...rest }) => (
    <BalanceComponent totals={totals} title={title} {...rest} />
  );
}

interface Props extends FormComponentProps {
  totals: {
    s: FormComponent;
    n: FormComponent;
    p2o5: FormComponent;
    k2o: FormComponent;
  };
  title?: string;
}

export function BalanceComponent(props: Props) {
  return (
    <fieldset className={css['group']}>
      <legend>
        <div className={css['title']}>
          <span>{props.title}</span>
        </div>
        <div className={css['totals']}>
          {<props.totals.s />}
          {<props.totals.n />}
          {<props.totals.p2o5 />}
          {<props.totals.k2o />}
        </div>
      </legend>
    </fieldset>
  );
}
